import React, { useEffect, useState } from "react";
import "../App.css";
import { Link, useNavigate } from "react-router-dom";
import logo from '../assets/logo.png';
import styles from './Login.module.css';
import "./RegisterForm.css";
import translations from "./translation.js";


const LoginForm = ({ setLoggedIn }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [sessionToken, setSessionToken] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const currentLanguage = localStorage.getItem('selectedLanguage') || "en";

  useEffect(() => {
    if (sessionStorage.getItem("token")) {
      navigate("/feed");
    }
  }, []);

  const submitHandler = (event) => {
    // event.preventDefault() prevents the browser from performing its default action
    // In this instance, it will prevent the page from reloading
    // keeps the form from actually submitting as well
    event.preventDefault();

    if (!email || !password || password.length < 8 || !/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
      if (!email) {
        setError(translations[currentLanguage].register_error_3);
      }
      else if (!password) {
        setError(translations[currentLanguage].register_error_2);
      }
      else if (password.length < 8 || !/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
        setError(translations[currentLanguage].password_error_1);
      }
      return;
    }

    fetch(process.env.REACT_APP_API_PATH + "/auth/login", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email,
        password,
      }),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.userID) {
          // Successfully logged in
          console.log(result);
          // set the auth token and user ID in the session state
          sessionStorage.setItem("token", result.token);
          sessionStorage.setItem("user", result.userID);
          // call setLoggedIn hook from App.jsx to save the login state throughout the app
          setLoggedIn(true);
          setSessionToken(result.token);
          console.log(sessionToken, " SESSION TOKEN");
          // go to the homepage

          const redirectURL = sessionStorage.getItem("redirectURL");
          if (redirectURL) {
            // If there's a redirect URL, clear it from session storage and redirect the user
            sessionStorage.removeItem("redirectURL");
            navigate(redirectURL);
          } else {
            navigate('/feed');
          }
          window.location.reload();
        }
      })
      .catch((err) => {
        setError(translations[currentLanguage].login_error_1);
        console.log(err);
      });
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.background}>
        <Link to='/' style={{ color: 'black', textDecoration: 'None', display: 'block', marginRight: 'auto' }}>
          <button className={styles.backBtn}>{translations[currentLanguage].back}</button>
        </Link>
        <img src={logo} alt="logo" className={styles.logoImage} />
        <form onSubmit={submitHandler} className={styles.regLogForm}>
          <input
            type="email"
            placeholder={translations[currentLanguage].email}
            onChange={(event) => {
              setEmail(event.target.value)
              setError("");
            }}
            className={styles.inputField}
          />
          <input
            type="password"
            placeholder={translations[currentLanguage].password}
            onChange={(event) => {
              setPassword(event.target.value);
              setError("");
            }}
            className={styles.inputField}
          />
          <Link to='/reset-password' className={styles.forgotPwd}>{translations[currentLanguage].forgot_password}</Link>
          <input type="submit" className={styles.loginStyle} value={translations[currentLanguage].login} />
        </form>
        {error && <div className="RegisterForm_error">{error}</div>}

        <div className={styles.prmtContainer}>
          <div className={styles.regPrmt}>
            {translations[currentLanguage].dont_have_account} <Link to='/register'>{translations[currentLanguage].register}</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;